import { getCurrentLanguage } from "utils/src/getCurrentLanguage";
import { apiClient } from "../../../../apps/crossword-maker/src/shared/apiClient";

export type TDeleteWord = (id: string) => Promise<void>;

export const deleteWord: TDeleteWord = async (id) => {
	const language = getCurrentLanguage();
	await apiClient().delete(`/rest/${language}/crossword-book/word/${id}`);
};
